export const VERTICAL_FILTER_STORAGE_ID = 'AppliedVerticalFilters';

/**
 * Each filter implementation has a unique filter set keyword and we should treat
 * them separately instead of combining two or more modules into one filter set
 * because it can create a lot of mess and confusion later.
 * So, when using VerticalFilterV2 component, we should refer to the corresponding
 * keyword in the localstorage to restore the filters.
 * Each implementation also has an optional "plan B" filter set where
 * we can restore from if we don't have filters applied for plan A.
 * Also refer to: https://www.notion.so/schoolinkshome/Scope-Filter-Usage-ab5dffde4da7461bb411561e5a5f3d5a
 */
export const FILTER_SETS = {
  ALUMNI_DATABASE: 'ALUMNI_DATABASE',
  BADGES: 'BADGES',
  CAREER_INTEREST_ANALYTICS: 'CAREER_INTEREST_ANALYTICS',
  CHECKINS: 'CHECKINS',
  COLLEGE_APPLICATION: 'COLLEGE_APPLICATION',
  COLLEGE_APPLICATION_MANAGER_DOCUMENT_MANAGER:
    'COLLEGE_APPLICATION_MANAGER_DOCUMENT_MANAGER',
  COLLEGE_APPLICATION_MANAGER_DOCUMENT_MANAGER_STUDENT_VIEW:
    'COLLEGE_APPLICATION_MANAGER_DOCUMENT_MANAGER_STUDENT_VIEW',
  COLLEGE_FINANCING: 'COLLEGE_FINANCING',
  COLLEGE_REP_EVENTS: 'COLLEGE_REP_EVENTS',
  CTE_PROGRAMS_DASHBOARD: 'CTE_PROGRAMS_DASHBOARD',
  COURSE_OFFERINGS: 'COURSE_OFFERINGS',
  COURSE_PLANNER: 'COURSE_PLANNER',
  DATA_UPLOAD_HISTORY: 'DATA_UPLOAD_HISTORY',
  DISTRICT_CONNECTIONS: 'DISTRICT_CONNECTIONS',
  DISTRICT_STAFF_LIST: 'DISTRICT_STAFF_LIST',
  DOCUMENT_CENTER: 'DOCUMENT_CENTER',
  ELEMENTARY_SCHOOL_STUDENT_LIST: 'ELEMENTARY_SCHOOL_STUDENT_LIST',
  EMPLOYER_SHOWCASE: 'EMPLOYER_SHOWCASE',
  EVENT_TEMPLATES: 'EVENT_TEMPLATES',
  EXPERIENCE_TRACKING: 'EXPERIENCE_TRACKING',
  EXPERIENCE_TRACKING_PDE: 'EXPERIENCE_TRACKING_PDE',
  MEMBER_EVENT_SCHEDULER_HOST: 'MEMBER_EVENT_SCHEDULER_HOST',
  FAFSA_TRACKER: 'FAFSA_TRACKER',
  INDUSTRY_PARTNER_DIRECTORY: 'INDUSTRY_PARTNER_DIRECTORY',
  INDUSTRY_PARTNER_EVENTS: 'INDUSTRY_PARTNER_EVENTS',
  INDUSTRY_PARTNER_PROGRAM_LIST: 'INDUSTRY_PARTNER_PROGRAM_LIST',
  INDUSTRY_PARTNER_PUBLIC_PROGRAM_LIST: 'INDUSTRY_PARTNER_PUBLIC_PROGRAM_LIST',
  INDUSTRY_PARTNER_PROGRAM_MANAGEMENT: 'INDUSTRY_PARTNER_PROGRAM_MANAGEMENT',
  INDUSTRY_PARTNER_PROGRAM_MANAGEMENT_CANDIDATES:
    'INDUSTRY_PARTNER_PROGRAM_MANAGEMENT_CANDIDATES',
  INDUSTRY_PARTNER_PROGRAM_MANAGEMENT_OPPORTUNITIES:
    'INDUSTRY_PARTNER_PROGRAM_MANAGEMENT_OPPORTUNITIES',
  INDUSTRY_PARTNER_PROGRAM_MANAGEMENT_PLACEMENTS:
    'INDUSTRY_PARTNER_PROGRAM_MANAGEMENT_PLACEMENTS',
  INTERNAL_EVENTS: 'INTERNAL_EVENTS',
  MEMBER_MANAGEMENT: 'MEMBER_MANAGEMENT',
  MIDDLE_AND_HIGH_SCHOOL_STUDENT_LIST: 'MIDDLE_AND_HIGH_SCHOOL_STUDENT_LIST',
  MIDDLE_AND_HIGH_SCHOOL_STUDENT_LIST_ANALYTICS:
    'MIDDLE_AND_HIGH_SCHOOL_STUDENT_LIST_ANALYTICS',
  OPPORTUNITIES: 'OPPORTUNITIES',
  PARTNER_EVENTS: 'PARTNER_EVENTS',
  PAST_EVENTS: 'PAST_EVENTS',
  PERSONALIZED_PLANS: 'PERSONALIZED_PLANS',
  PENDING_EVENTS: 'PENDING_EVENTS',
  PUBLIC_UPCOMING_EVENTS: 'PUBLIC_UPCOMING_EVENTS',
  REPORT_CENTER: 'REPORT_CENTER',
  ROSTERS_AND_TAGS_STAFF_ROSTERS: 'ROSTERS_AND_TAGS_STAFF_ROSTERS',
  ROSTERS_AND_TAGS_STUDENT_TAGS: 'ROSTERS_AND_TAGS_STUDENT_TAGS',
  SCHOOL_SEARCH: 'SCHOOL_SEARCH',
  SCOPE_AND_SEQUENCE_ANALYTICS: 'SCOPE_AND_SEQUENCE_ANALYTICS',
  SCOPE_AND_SEQUENCE_VERIFICATION: 'SCOPE_AND_SEQUENCE_VERIFICATION',
  SENIOR_YEAR_END_ANALYTICS: 'SENIOR_YEAR_END_ANALYTICS',
  SPONSOR_OPPORTUNITIES: 'SPONSOR_OPPORTUNITIES',
  STAFF_LIST: 'STAFF_LIST',
  STUDENT_PATHWAYS: 'STUDENT_PATHWAYS',
  SURVEY_ANALYTICS: 'SURVEY_ANALYTICS',
  TRANSCRIPT_CENTER: 'TRANSCRIPT_CENTER',
  SCHEDULED_EVENTS: 'SCHEDULED_EVENTS',
  KRI_ANALYTICS: 'KRI_ANALYTICS',
};

export const ELEMENTARY_GRADE_OPTIONS = [
  {
    title: 'Kindergarten',
    value: 0,
  },
  {
    title: '1st',
    value: 1,
  },
  {
    title: '2nd',
    value: 2,
  },
  {
    title: '3rd',
    value: 3,
  },
  {
    title: '4th',
    value: 4,
  },
  {
    title: '5th',
    value: 5,
  },
];

export const GRADE_OPTIONS = [
  {
    title: '6th',
    value: 6,
  },
  {
    title: '7th',
    value: 7,
  },
  {
    title: '8th',
    value: 8,
  },
  {
    title: '9th',
    value: 9,
  },
  {
    title: '10th',
    value: 10,
  },
  {
    title: '11th',
    value: 11,
  },
  {
    title: '12th',
    value: 12,
  },
];

export const POST_SECONDARY_GOAL_OPTIONS = [
  {
    title: '4-year degree',
    value: '4-year degree',
  },
  {
    title: '2-year degree',
    value: '2-year degree',
  },
  {
    title: 'Trade school',
    value: 'trade school',
  },
  {
    title: 'Apprenticeship',
    value: 'apprenticeship',
  },
  {
    title: 'Internship',
    value: 'internship',
  },
  {
    title: 'Workforce',
    value: 'workforce',
  },
  {
    title: 'Gap year',
    value: 'gap year',
  },
  {
    title: 'Volunteer',
    value: 'volunteer',
  },
  {
    title: 'Military',
    value: 'military',
  },
];

export const BULK_ACTION_TYPES = {
  MESSAGE: 'message',
  EXPORT: 'export',
  OTHER: 'other',
};

export const TEST_BULK_ACTION_REPORT_OPTIONS = [
  {
    id: 'submission',
    label: 'Application Submission',
    type: 'CSV',
  },
  {
    id: 'summary',
    label: 'Test Summary Report',
    type: 'PDF',
  },
];

export const TEST_BULK_ACTION_ADDITIONAL_INSTRUCTIONS = [
  {
    id: 1,
    label: 'Test Additional Option',
  },
  {
    id: 2,
    label: 'Test Additional Option Two',
  },
];

export const TOOLTIP_TEXT =
  'Show students who have at least one (“any”) of your selected items, or all of them.';

export const TRUE_FILTER_STRING = 'true';

export const ANY_VALUE_IS_VALID = 'any';
export const VALID_STANDALONE_VALUES = [true, false, 'true', 'false'];
export const FREE_TEXT_SEARCH = 'FREE_TEXT_SEARCH';
export const FREE_RESPONSES = 'freeResponses';
export const CUSTOM_KEYS = [FREE_RESPONSES];

export const GROUP_MODIFIER_SIZE = Object.freeze({
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
});

export const START_DATETIME_PARAM = 'start_datetime__gte';
export const END_DATETIME_PARAM = 'end_datetime__lt';
export const START_DATETIME_LTE_PARAM = 'start_datetime__lte';
